import { green, orange, deepOrange, red } from '@mui/material/colors';

export const defaultProjectColor = '#1976D2';

export const legendColors = [
    green[300],
    green[600],
    green[900],
    orange[200],
    orange[500],
    orange[700],
    deepOrange[400],
    red[500],
    red[900],
];
